import React, { useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import localeText from "../../../../../../locale";
import { useToastContext } from "../../../../../../contexts/ToastContext/ToastContext";
import {
  buildLocalizedUrl,
  getLocale,
  setUserLocale,
} from "../../../../../../utilities/locale/locale";

const LANGUAGES = [
  { label: "Português", iso639: "pt" },
  { label: "Italiano", iso639: "it" },
  { label: "Español", iso639: "es" },
  { label: "English", iso639: "en" },
];

function getBrowserTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  } catch {
    return "";
  }
}

function getBrowserTimeFormat() {
  try {
    const hour12 = Intl.DateTimeFormat(undefined, { hour: "numeric" }).resolvedOptions().hour12;
    return hour12 ? "12 " + localeText("hours") : "24 " + localeText("hours");
  } catch {
    return "24h";
  }
}

function getBrowserDateFormat() {
  try {
    const opt = Intl.DateTimeFormat(undefined, {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    }).resolvedOptions();
    const hasDayFirst = opt.day === "2-digit" || opt.month === "2-digit";
    return hasDayFirst ? "DD/MM/YY" : "MM/DD/YY";
  } catch {
    return "DD/MM/YY";
  }
}

const RegionalPreferences = () => {
  const { showSuccessToast } = useToastContext();
  const currentLocale = getLocale();
  const [selectedLanguage, setSelectedLanguage] = useState(
    LANGUAGES.find((l) => l.iso639 === currentLocale) || LANGUAGES[3],
  );
  const [timezone] = useState(getBrowserTimezone);
  const [timeFormat] = useState(getBrowserTimeFormat);
  const [dateFormat] = useState(getBrowserDateFormat);

  const handleApply = () => {
    setUserLocale(selectedLanguage.iso639);

    showSuccessToast({ detail: "sucessfullyEditedProfile" });

    window.location.href = buildLocalizedUrl(selectedLanguage.iso639);
  };

  return (
    <div>
      <h2 className="text-lg font-semibold m-0 mb-1" style={{ color: "var(--theme-text)" }}>
        {localeText("regionalPreferences")}
      </h2>
      <p className="text-sm m-0 mb-3" style={{ color: "var(--theme-text-muted)" }}>
        {localeText("regionalPreferencesSubtitle")}
      </p>
      <hr className="mb-3" />
      <div className="flex flex-column gap-3">
        <div>
          <label className="block text-sm mb-1 font-medium" style={{ color: "var(--theme-text)" }}>
            {localeText("language")} *
          </label>
          <Dropdown
            value={selectedLanguage}
            options={LANGUAGES}
            onChange={(e) => setSelectedLanguage(e.value)}
            optionLabel="label"
            className="w-full p-no-outline border-round-md"
            style={{ color: "var(--theme-text)" }}
          />
        </div>
        <div>
          <label className="block text-sm mb-1 font-medium" style={{ color: "var(--theme-text)" }}>
            {localeText("timezone")} *
          </label>
          <InputText
            value={timezone}
            className="w-full p-no-outline border-round-md"
            disabled
            style={{ color: "var(--theme-text)" }}
          />
        </div>
        <div>
          <label className="block text-sm mb-1 font-medium" style={{ color: "var(--theme-text)" }}>
            {localeText("timeFormatOptional")}
          </label>
          <InputText
            value={timeFormat}
            className="w-full p-no-outline border-round-md"
            disabled
            style={{ color: "var(--theme-text)" }}
          />
        </div>
        <div>
          <label className="block text-sm mb-1 font-medium" style={{ color: "var(--theme-text)" }}>
            {localeText("dateFormatOptional")}
          </label>
          <InputText
            value={dateFormat}
            className="w-full p-no-outline border-round-md"
            disabled
            style={{ color: "var(--theme-text)" }}
          />
        </div>
        <div className="flex gap-2 mt-2" style={{ height: "40px" }}>
          <Button
            label={localeText("cancel")}
            className="p-button-outlined border-round-md flex-1 text-sm font-medium"
            style={{ borderColor: "var(--theme-border)", color: "var(--theme-text-muted)" }}
          />
          <Button
            label={localeText("applyChanges")}
            className="border-round-md flex-1 text-sm font-medium"
            style={{ backgroundColor: "var(--theme-primary)", color: "#fff", border: "none" }}
            onClick={handleApply}
          />
        </div>
      </div>
    </div>
  );
};

export default RegionalPreferences;
